import * as entity from '@common/domain/entities/Supplier'
import { FormBuilderControlListHelper } from '../../formbuilder/FormBuilderControlListHelper';
export class SupplierEndPoints extends entity.SupplierEndPoints { }

export class SupplierFormFields extends entity.SupplierFormFields {
  constructor() {
    super();
    try {
      if (this["id"]) this.splice(this.indexOf(this["id"]), 1)
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
      if (this["addressContact"]) this.splice(this.indexOf(this["addressContact"]), 1)
      if (this["postalAddressContact"]) this.splice(this.indexOf(this["postalAddressContact"]), 1)
      if (this["sisproSupplierTimestamp"]) this.splice(this.indexOf(this["sisproSupplierTimestamp"]), 1)
      if (this["sisproSupplierExtTimestamp"]) this.splice(this.indexOf(this["sisproSupplierExtTimestamp"]), 1)
      if (this["sisproSupplierAddrTimestamp"]) this.splice(this.indexOf(this["sisproSupplierAddrTimestamp"]), 1)

      if (this["status"]) this.splice(this.indexOf(this["status"]), 1)
      if (this["taxCodeId"]) this.splice(this.indexOf(this["taxCodeId"]), 1)
if (this["branch"]) this.splice(this.indexOf(this["branch"]), 1)
      
      this.sisproSupplierTimestamp.readOnly = true;
      this.sisproSupplierExtTimestamp.readOnly = true;
      this.sisproSupplierAddrTimestamp.readOnly = true;
      this.sisproName.readOnly = true;
      this.sisproShortName.readOnly = true;
      //this.branch.readOnly = true;
      this.contact.readOnly = true;
      this.telephone.readOnly = true;
      this.fax.readOnly = true;
      this.email.readOnly = true;
      this.beeRating.readOnly = true;
      this.beeExpiryDate.readOnly = true;
      this.beeCompanyRegistration.readOnly = true;
      this.companyRegNo.readOnly = true;
      this.address1.readOnly = true;
      this.address2.readOnly = true;
      this.address3.readOnly = true;
      this.address4.readOnly = true;
      this.address5.readOnly = true;
      this.addressContact.readOnly = true;
      this.postalAddress1.readOnly = true;
      this.postalAddress2.readOnly = true;
      this.postalAddress3.readOnly = true;
      this.postalAddress4.readOnly = true;
      this.postalAddress5.readOnly = true;
      this.postalAddressContact.readOnly = true;
      this.email.readOnly = true;
      this.sisproName.name = "Name";
      this.sisproShortName.name = "Short Name";
      this.splice(this.indexOf(this.sisproName), 1);
      
    } catch  { }
  }
}

export class SupplierForm extends entity.SupplierForm {
  protected supplierFormEndPoints: SupplierEndPoints = new SupplierEndPoints();
  protected supplierFormFields: SupplierFormFields = new SupplierFormFields();
}

export class SupplierListColumns extends entity.SupplierListColumns {
  constructor() {
    super();
    try {
      if (this["id"]) this["id"].visible = false;
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
     // if (this["status"]) this.splice(this.indexOf(this["status"]), 1)
      if (this["addressContact"]) this.splice(this.indexOf(this["addressContact"]), 1)
      if (this["postalAddressContact"]) this.splice(this.indexOf(this["postalAddressContact"]), 1)
      if (this["sisproSupplierTimestamp"]) this.splice(this.indexOf(this["sisproSupplierTimestamp"]), 1)
      if (this["sisproSupplierExtTimestamp"]) this.splice(this.indexOf(this["sisproSupplierExtTimestamp"]), 1)
      if (this["sisproSupplierAddrTimestamp"]) this.splice(this.indexOf(this["sisproSupplierAddrTimestamp"]), 1)

      this.code.width = 120;
      this.branch.width = 120;
      this.sisproSupplierTimestamp.readOnly = true;
      this.sisproSupplierExtTimestamp.readOnly = true;
      this.sisproSupplierAddrTimestamp.readOnly = true;
      this.sisproName.readOnly = true;
      this.sisproShortName.readOnly = true;
      this.branch.readOnly = true;
this.branch.field = 'sysproBranch.code'
this.branch.dbField = 'sysproBranch_code'
this.branch.name = 'Branch'
      this.contact.readOnly = true;
      this.telephone.readOnly = true;
      this.fax.readOnly = true;
      this.email.readOnly = true;
      this.sisproName.name = "Name";
      this.sisproShortName.name = "Short Name";
      var temp: any = this.status;
      temp.template = function (t) {
        return t == "1" ? "Active" : "On Hold"
      };
      temp.width = 120;
      this.splice(this.indexOf(this.sisproName), 1);
      this.splice(this.indexOf(this.taxCodeId), 1);
      this.splice(this.indexOf(this.beeRating),1);
      this.splice(this.indexOf(this.beeExpiryDate),1);
      this.splice(this.indexOf(this.beeCompanyRegistration),1);
      this.splice(this.indexOf(this.companyRegNo),1);
      this.splice(this.indexOf(this.address1),1);
      this.splice(this.indexOf(this.address2),1);
      this.splice(this.indexOf(this.address3),1);
      this.splice(this.indexOf(this.address4),1);
      this.splice(this.indexOf(this.address5),1);
      this.splice(this.indexOf(this.addressContact),1);
      this.splice(this.indexOf(this.postalAddress1),1);
      this.splice(this.indexOf(this.postalAddress2),1);
      this.splice(this.indexOf(this.postalAddress3),1);
      this.splice(this.indexOf(this.postalAddress4),1);
      this.splice(this.indexOf(this.postalAddress5),1);
      this.splice(this.indexOf(this.postalAddressContact),1);
    } catch  { }
  }
}

export class SupplierList extends entity.SupplierList {
  protected supplierListEndPoints: SupplierEndPoints = new SupplierEndPoints();
  protected supplierListColumns: SupplierListColumns = new SupplierListColumns();
}
//export class SupplierGeneratedForm extends entity.SupplierGeneratedForm {
  //protected detailPageComponentForm: SupplierForm = new SupplierForm();
//};

//export class SupplierListPageComponent extends entity.SupplierListPageComponent {
  //protected listPageComponentList: SupplierList = new SupplierList();
  //protected showFilterColOnTable: boolean = true;
//};

//export class SupplierBlade extends entity.SupplierBlade {};
//export class SupplierListBlade extends entity.SupplierListBlade {};

